import { Card, CardContent, CardFront } from '@plato/ui/containers/card';
import { cn } from '@plato/ui/util/classes';
import type { ReactNode } from 'react';

// Three cards, a typical day; the names differ in length so the cards don't read as one repeated block
const nameWidths = ['w-40', 'w-32', 'w-36'];

/**
 * A day whose events are on their way, as in the design: the real card frame with a bar per line,
 * the name on top and the time and place below. The lines keep the card's line heights, so nothing
 * jumps when the events arrive.
 */
export function DaySkeleton(): ReactNode {
    return (
        <div aria-hidden className="flex flex-col gap-cozy">
            {nameWidths.map((nameWidth) => (
                <Card key={nameWidth} className="shadow-xs">
                    <CardFront>
                        <CardContent className="gap-tight">
                            <span className="flex h-5 items-center">
                                <span
                                    className={cn(
                                        'block h-3 animate-pulse rounded bg-neutral-300',
                                        nameWidth,
                                    )}
                                />
                            </span>
                            <span className="flex h-4 items-center justify-between">
                                <span className="block h-2.5 w-20 animate-pulse rounded bg-neutral-200" />
                                <span className="block h-2.5 w-14 animate-pulse rounded bg-neutral-200" />
                            </span>
                        </CardContent>
                    </CardFront>
                </Card>
            ))}
        </div>
    );
}
